<div class="dm-body">
  <div
    class="dm-icon-wrap"
    [class.logout]="iconKind === 'logout'"
    [class.approve]="iconKind === 'approve'"
    [class.reject]="iconKind === 'reject'"
    [class.status]="iconKind === 'status'"
    [class.absent]="iconKind === 'absent'"
    [class.info]="iconKind === 'password' || iconKind === 'print' || iconKind === 'promote'"
    [class.clear]="iconKind === 'clear'"
  >
    <svg
      class="dm-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      @switch (iconKind) {
        @case ('logout') {
          <path d="M12 2v10" />
          <path d="M18.4 6.6a9 9 0 1 1-12.77.04" />
        }
        @case ('approve') {
          <path d="M21.801 10A10 10 0 1 1 17 3.335" />
          <path d="m9 11 3 3L22 4" />
        }
        @case ('reject') {
          <circle cx="12" cy="12" r="10" />
          <path d="m15 9-6 6" />
          <path d="m9 9 6 6" />
        }
        @case ('status') {
          <path d="M8 3 4 7l4 4" />
          <path d="M4 7h16" />
          <path d="m16 21 4-4-4-4" />
          <path d="M20 17H4" />
        }
        @case ('absent') {
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <path d="M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0" />
          <path d="m17 8 5 5" />
          <path d="m22 8-5 5" />
        }
        @case ('password') {
          <rect width="18" height="11" x="3" y="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        }
        @case ('clear') {
          <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
          <path d="M22 21H7" />
          <path d="m5 11 9 9" />
        }
        @case ('print') {
          <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
          <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
          <rect x="6" y="14" width="12" height="8" rx="1" />
        }
        @case ('promote') {
          <path
            d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"
          />
          <path d="M22 10v6" />
          <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5" />
        }
        @default {
          <path d="M3 6h18" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <path d="M10 11v6" />
          <path d="M14 11v6" />
        }
      }
    </svg>
  </div>
  <div class="dm-content">
    <h4 class="dm-title">{{ data.modalTitle || 'Confirm' }}</h4>
    <p class="dm-msg">{{ data.msg || 'Are you sure you want to continue?' }}</p>
    <div class="dm-actions">
      <button type="button" class="dm-btn-cancel" (click)="onCancel()">
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        class="dm-btn-confirm"
        [class.dm-btn-confirm--logout]="iconKind === 'logout'"
        (click)="onConfirm()"
      >
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>
